import type { ListingTypeOptions } from "@/utils/productTypes";
import { formatCurrency } from "toolbox/Money";

import type { RecommendationSlideData } from "./RecommendationSlide";

type RecommendationItem = {
  id: string;
  type: string;
  imageUrl?: string | null;
  title?: string;
  baseCost?: number;
  membershipCost?: number | null;
};

export const transformRecommendationsToSlides = (
  listings: RecommendationItem[]
): RecommendationSlideData[] => {
  return listings.map(
    ({ id, type, imageUrl, title, baseCost, membershipCost }) => ({
      id,
      type: type as ListingTypeOptions,
      image: imageUrl ?? "",
      title: title ?? "",
      price: formatCurrency(baseCost ?? 0),
      memberPrice:
        typeof membershipCost === "number" &&
        !!membershipCost &&
        membershipCost != baseCost
          ? formatCurrency(membershipCost)
          : null,
    })
  );
};
